export var defaultPrefetchOptions = {
    staleTime: Infinity,
    cacheTime: Infinity,
};
//# sourceMappingURL=defaultPrefetchOptions.js.map